//https://www.npmjs.com/package/xlsexport, https://jsfiddle.net/3xvb2g5w/
// import XlsExport from 'xlsexport';
// http://sheetjs.com/
// https://docs.sheetjs.com/#number-formats
import XLSX from 'xlsx';
import { _formatDate } from './objectToFormData';
/**
 *
 * @param rows
 * @param fileName
 * @param formats
 * @returns {string}
 */
export function toXLSX(rows, fileName, formats) {
    if (formats === void 0) { formats = []; }
    exportToFile(rows, 'xlsx', fileName, formats);
}
/**
 *
 * @param rows
 * @param fileName
 * @param formats
 * @returns {string}
 */
export function toCSV(rows, fileName, formats) {
    if (formats === void 0) { formats = []; }
    exportToFile(rows, 'csv', fileName, formats);
}
/**
 *
 * @param rows
 * @param format
 * @param fileName
 * @param formats
 */
function exportToFile(rows, format, fileName, formats) {
    if (formats === void 0) { formats = []; }
    var date = new Date();
    var sheetName = 'Sheet 1';
    if (!fileName) {
        fileName = 'export-' + _formatDate(date);
    }
    var ws = XLSX.utils.aoa_to_sheet(rows);
    var _loop_1 = function (i) {
        formats.forEach(function (format) {
            if (format.format) {
                ws[format.column + i].z = format.format;
            }
            if (format.type) {
                ws[format.column + i].t = format.type;
            }
        });
    };
    // Apply format from second row (1st - header)
    for (var i = 2; i <= rows.length; i++) {
        _loop_1(i);
    }
    var wb = XLSX.utils.book_new();
    wb.SheetNames.push(sheetName);
    wb.Sheets[sheetName] = ws;
    XLSX.writeFile(wb, fileName + '.' + format);
}
